import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "Dropdown", "dropdownButtonText", "dropdownProps"];
import { Collapser } from '../Collapser/Collapser';
import { Dropdown } from '../Dropdown';
import { List } from '../List';
import I18n from 'I18n';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCollapserWrapper = styled.div.withConfig({
  displayName: "ButtonCollapser__StyledCollapserWrapper"
})(({
  theme
}) => ({
  // Target the span elements that Collapser creates (nested inside View)
  '& > * > span + span': {
    marginInlineStart: theme.space['300']
  }
}));
export const ButtonCollapser = _ref => {
  let {
      children,
      Dropdown: DropdownComponent = Dropdown,
      dropdownButtonText = I18n.text('ui.UIButtonCollapser.dropdownLabel'),
      dropdownProps
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledCollapserWrapper, {
    children: /*#__PURE__*/_jsx(Collapser, Object.assign({}, rest, {
      fallback: /*#__PURE__*/_jsx(DropdownComponent, Object.assign({
        buttonText: dropdownButtonText
      }, dropdownProps, {
        children: /*#__PURE__*/_jsx(List, {
          wrapChildren: true,
          children: children
        })
      })),
      children: children
    }))
  });
};
ButtonCollapser.displayName = 'ButtonCollapser';